export default function getResource(label, vars = []) {
    const resources = {
        modalTitle: 'Réinitialiser le mot de passe',
        resetPasswordMessage: 'Pour réinitialiser votre mot de passe, veuillez saisir votre adresse de courriel ci-dessous. Nous vous enverrons un courriel contenant un lien qui vous permettra de réinitialiser votre mot de passe.',
        emailLabel: 'Adresse de courriel',
        sendEmailButton: 'Envoyer un courriel',
        stillHavingTroublesMsg: 'Vous avez toujours des difficultés?',
        unableResetPasswordMessage: 'Si vous ne parvenez pas à réinitialiser votre mot de passe, veuillez appeler le Service à la clientèle au',
        sephoraPhoneNumber: '1-877-SEPHORA',
        phoneNumberTTY: '(1-877-737-4672)',
        phoneNumber: '1-888-866-9845',
        forAssistanceMessage: 'Surdité et déficience auditive/ATS Voir',
        accessibility: 'Accessibilité',
        resetPassword: 'Réinitialiser le mot de passe',
        confirmationMessage: 'Nous avons envoyé un courriel à',
        confirmationMessage2: 'Veuillez vérifier votre boîte de réception et cliquer sur le lien pour réinitialiser votre mot de passe.',
        confirmButton: 'OK',
        fallbackErrorMsg: 'Si vous ne parvenez pas à réinitialiser votre mot de passe, veuillez appeler le service à la clientèle pour obtenir de l’aide.',
        fallbackPasskeyErrorMsg: 'Si vous ne parvenez pas à réinitialiser votre clé d’accès, veuillez communiquer avec le service à la clientèle pour obtenir de l’aide.',
        forgotYourPasswordTitle: 'Mot de passe oublié?',
        passkeysIntroMessage: 'Sephora passe aux clés d’accès. Passez aux empreintes digitales, au NIP ou au mot de passe de l’appareil pour une connexion plus rapide et plus sécuritaire. Nous ne recevons jamais vos données biométriques comme les empreintes digitales ou les balayages faciaux.',
        verifyEmailMessage: 'Entrez votre adresse courriel ci-dessous pour vérifier votre compte.',
        sharedDeviceDisclaimer: 'Non recommandé pour les appareils partagés.',
        termsAndConditions: 'By clicking "Continue", you (1) agree to the current version of our ',
        termsOfUse: 'CONDITIONS D’UTILISATION',
        termsAndConditionsRest: ' et (2) confirmez avoir lu notre ',
        privacyPolicy: 'politique de confidentialité',
        resetMyPasswordCta: 'Reset My Password Instead',
        createNewPasskeyCta: 'Continue',
        errorPasskeyMaxAttempts: 'Vous avez atteint le nombre maximal d’essais pour réinitialiser votre clé d’accès. Veuillez réessayer plus tard.'
    };

    return resources[label];
}
